define('SageDotCom/Components/LottieAnimationLottie',[
    "jquery", "eventManager"
],
    function ($, eventManager) {
        function LottieAnimation(scope) {
            var lottieEl = scope.querySelector("dotlottie-player");
            if (typeof lottieEl.getState === "undefined") {
                //Lottie functions not available
                return;
            }

            var lottieID = lottieEl.getAttribute("data-lottie");
            var lottieContainer = scope.querySelector(".lottie-container-" + lottieID);
            var playBtn = lottieContainer.querySelector(".playLottie");
            var stopBtn = lottieContainer.querySelector(".stopLottie");
            var finished = false;
            var controls = lottieContainer.querySelector(".lottie-controls");
            var isInitialLoad = true;
            var dataControlsSwitched = false;
            var body = document.querySelector("body");
            var isReducedMotion = (window.matchMedia('(prefers-reduced-motion: reduce)')).matches;
            var isHoverRemovedOnMobile = false;
            var currentWidth = window.innerWidth;
            var resizeTimeout = null;

            $(window).on("resize",
                function () {
                    if (!isInitialLoad && window.innerWidth !== currentWidth) {
                        if (resizeTimeout) {
                            clearTimeout(resizeTimeout);
                        }
                        resizeTimeout = setTimeout(function () {
                            $(lottieEl).off();
                            removeHoverOnMobile();
                            checkOnHover();
                            currentWidth = window.innerWidth;
                        },
                            500);
                    }
                    isInitialLoad = false;
                });

            const handleClassChange = (mutationsList, observer) => {
                mutationsList.forEach((mutation) => {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                        const usingKbd = body.classList.contains('using-kbd');

                        if (usingKbd) {
                            if (lottieEl.classList.contains("on-hover")) {
                                lottieEl.classList.remove('on-hover');
                            }

                            if ($(controls).attr("data-controls") === "false") {
                                $(controls).attr("data-controls", "true");
                                stopBtn.classList.remove('hover');
                                playBtn.classList.add('hover');
                                playBtn.classList.add('stopped');
                            }

                            if ($(controls).hasClass("loop")) {
                                stopBtn.classList.remove('loop');
                                playBtn.classList.add('loop');
                            }

                            lottieEl.load(lottieEl.src);
                            checkOnHover();
                            observer.disconnect();
                        }
                    }
                });
            };

            const observer = new MutationObserver(handleClassChange);
            const observerConfig = { attributes: true };

            observer.observe(body, observerConfig);

            function pauseCurrentAnimation() {
                lottieEl.pause();
            }

            var addMouseOutPause = function () {
                $(lottieEl).on('mouseout', pauseCurrentAnimation);
            }

            var removeHoverOnMobile = function () {
                if ($(window).width() < 1080) {
                    if (lottieEl.classList.contains("on-hover")) {
                        lottieEl.classList.remove('on-hover');
                    }
                    if (playBtn.classList.contains('loop')) {
                        playBtn.classList.remove('loop')
                    }
                    if (playBtn.classList.contains('stopped')) {
                        playBtn.classList.remove('stopped');
                    }
                    lottieEl.removeAttribute('hover');
                    isHoverRemovedOnMobile = true;
                    lottieEl.load(lottieEl.src);
                } else {
                    if (!lottieEl.classList.contains('on-hover') && !lottieEl.classList.contains('scroll-into-view')) {
                        lottieEl.classList.add('on-hover');
                    }
                    addMouseOutPause();
                }
            }

            function mouseoverEvent(e) {
                if (lottieEl.getState().currentState === "paused") {
                    playBtn.classList.add('hover');
                } else if (finished !== true) {

                    stopBtn.classList.add('hover');
                }
                if ($(controls).attr("data-controls") === 'false') {
                    controls.classList.add("hover");
                }
            }

            function mouseoutEvent(e) {
                if ($(controls).attr("data-controls") === 'false') {
                    controls.classList.remove("hover");
                }
                playBtn.classList.remove('hover');
                stopBtn.classList.remove('hover');
            }

            checkOnHover();

            function checkOnHover() {

                if (lottieEl.classList.contains("on-hover") && ($(window).width() > 1080) && (!isReducedMotion)) {

                    lottieEl.setAttribute('hover', 'true');
                    playBtn.classList.remove("finished");
                    controls.classList.remove("hover");

                    if ($(controls).attr("data-controls") === "true") {
                        $(controls).attr("data-controls", "false");
                        dataControlsSwitched = true;
                    }
                    lottieEl.load(lottieEl.src);
                    $(lottieContainer).off();

                    addMouseOutPause();


                } else {

                    if ((!controls.classList.contains('loop')) && (lottieEl.getAttribute('loop') === "")) {
                        lottieEl.setLooping(false);
                    }

                    if (dataControlsSwitched === true) {
                        $(controls).attr("data-controls", "true");
                        dataControlsSwitched = false;
                    }

                    var scrollTimer = null;

                    eventManager.subscribe("lottie-load", function (scope) {
                        CheckTabset();
                    }, this);

                    function checkReducedMotion() {
                        if (isReducedMotion) {
                            lottieEl.seek("100%");
                        }
                    }

                    lottieEl.addEventListener('ready', checkReducedMotion());

                    if (isReducedMotion) {
                        return;
                    }

                    //timers
                    var defaultTimeoutDuration = 300;

                    if ($(controls).hasClass("loop")) {
                        if (lottieEl.getState().currentState === "paused") {
                            playBtn.classList.add('loop');
                        } else if (!body.classList.contains('using-kbd')) {
                            stopBtn.classList.add('loop');
                        }
                    }

                    $(lottieContainer).on("mouseover", mouseoverEvent());
                    $(lottieContainer).on("mouseout", mouseoutEvent());

                    function play() {
                        if (finished === true) {
                            playBtn.classList.remove('finished');
                            lottieEl.stop();
                        }
                        playBtn.classList.remove('hover');
                        playBtn.classList.remove('stopped');
                        stopBtn.classList.add('hover');
                        if ($(controls).attr("data-controls") === 'false') {
                            controls.classList.add("hover");
                        }
                        if ($(controls).hasClass("loop")) {
                            playBtn.classList.remove('loop');
                            stopBtn.classList.add('loop');
                        }
                        playCurrentAnimation();
                        finished = false;
                    }
                    function pause() {
                        stopBtn.classList.remove('hover');
                        playBtn.classList.add('hover');
                        if ($(controls).attr("data-controls") === 'false') {
                            controls.classList.add("hover");
                        }
                        playBtn.classList.add('stopped');
                        if ($(controls).hasClass("loop")) {
                            stopBtn.classList.remove('loop');
                            playBtn.classList.add('loop');
                        }
                        pauseCurrentAnimation();
                    }

                    playBtn.addEventListener('click', function (e) {
                        play();
                        stopBtn.focus();
                    });
                    playBtn.addEventListener('keydown', function (e) {
                        if (13 === e.keyCode) {
                            play();
                            stopBtn.focus();
                        }
                    });
                    stopBtn.addEventListener('keydown', function (e) {
                        if (13 === e.keyCode) {
                            pause();
                            playBtn.focus();
                        }
                    });
                    stopBtn.addEventListener('click', function (e) {
                        pause();
                        playBtn.focus();
                    });

                    $(stopBtn).on("focusout", function () {
                        pause();
                    });

                    lottieEl.addEventListener('complete', function (e) {

                        if (stopBtn.classList.contains('hover')) {
                            stopBtn.classList.remove('hover');
                            playBtn.classList.add('hover');
                            if ($(controls).hasClass("loop")) {
                                playBtn.classList.add('loop');
                                stopBtn.classList.remove('loop');
                            }
                        }
                        playBtn.classList.add('finished');
                        finished = true;
                        if ($(controls).attr("data-controls") === 'false') {
                            controls.classList.add("hover");
                        }
                    });

                    //start playing logic
                    CheckTabset();

                    //Helpers and Utils :
                    function addOnce(el, evtName, handler) {
                        var wrapped = function (e) {
                            try { handler(e); } finally { el.removeEventListener(evtName, wrapped); }
                        };
                        el.addEventListener(evtName, wrapped);
                    }

                    function safePlay(el) {
                        el = el || lottieEl;
                        if (!el || typeof el.getState !== "function") return;

                        var stateObj = el.getState();
                        var state = stateObj && stateObj.currentState;

                        if (state === "loading" || !state) {
                            addOnce(el, "ready", function () {
                                try { el.play(); } catch (e) { console.error("dotlottie play after ready failed", e); }
                            });
                            addOnce(el, "loadError", function (ev) {
                                console.error("dotlottie loadError", ev && ev.detail ? ev.detail : ev);
                            });
                            addOnce(el, "error", function (ev) {
                                console.error("dotlottie error", ev && ev.detail ? ev.detail : ev);
                            });
                        } else if (state === "ready" || state === "paused" || state === "stopped") {
                            try { el.play(); } catch (e) { console.error("dotlottie play failed", e); }
                        } else {
                            addOnce(el, "ready", function () {
                                try { el.play(); } catch (e) { console.error("state unknown, attempting to play failed", e); }
                            });
                        }
                    }

                    function checkElementInViewPort() {
                        if (scrollTimer) {
                            clearTimeout(scrollTimer);
                        }
                        scrollTimer = setTimeout(function () {
                            var res = isElementPartiallyInViewport(lottieContainer) && $(lottieContainer).is(":visible");
                            if (res) {
                                playCurrentAnimation();
                                document.removeEventListener('scroll', checkElementInViewPort);
                            }
                        }, defaultTimeoutDuration);
                    }

                    function isElementPartiallyInViewport(el) {
                        // Special bonus for those using jQuery
                        if (typeof jQuery !== 'undefined' && el instanceof jQuery)
                            el = el[0];

                        var rect = el.getBoundingClientRect();
                        var windowHeight = (window.innerHeight || document.documentElement.clientHeight);
                        var windowWidth = (window.innerWidth || document.documentElement.clientWidth);
                        var vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
                        var horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

                        return (vertInView && horInView);
                    }

                    function WaitForSlickToBeActive(selector, callback) {
                        var interval = setInterval(function () {
                            if ($(selector).hasClass("slick-active")) {
                                clearInterval(interval);
                                callback();
                            }
                        },
                            defaultTimeoutDuration
                        );
                    }

                    function WaitToBeSlick() {
                        WaitForSlickToBeActive($(lottieEl).closest(".slick-slide"), function () {
                            lottieEl.load(lottieEl.src);
                            lottieEl.addEventListener('ready', () => {
                                playCurrentAnimation();
                            });
                        });
                    }
                    function PlayAnimation() {
                        if ($(lottieEl).parents().hasClass("slick-slide") && $(lottieEl).parents().hasClass("tab-pane")) {
                            WaitToBeSlick();
                        } else {
                            playCurrentAnimation();
                        }
                    }

                    function isElementVisibleAndInViewport() {
                        return $(lottieContainer).is(":visible") && isElementPartiallyInViewport(lottieContainer);
                    }

                    function waitForElementVisibleInViewport(callback) {
                        var interval = setInterval(function () {
                            if (isElementVisibleAndInViewport()) {
                                clearInterval(interval);
                                callback();
                            }
                        },
                            defaultTimeoutDuration
                        );
                    }

                    function CheckTabset() {
                        if ($(lottieEl).parents().hasClass("score-tab") && $(".score-tab").is(":visible")) {
                            //when showing tabset
                            pauseCurrentAnimation(); //initial state of animation
                            if (!isElementVisibleAndInViewport()) {
                                waitForElementVisibleInViewport(function () {
                                    PlayAnimation();
                                });
                            } else if ($(lottieEl).parents().hasClass("slick-slide") && $(lottieEl).parents().hasClass("tab-pane")) {
                                //is on tabs with slick slider
                                //wait for the second tab to be visible
                                WaitToBeSlick();
                            } else {
                                playCurrentAnimation();
                            }
                        }
                        else {
                            //when NOT showing tabset
                            if (!body.classList.contains('using-kbd')) {
                                if (isElementPartiallyInViewport(lottieContainer)) {
                                    playCurrentAnimation();
                                } else {
                                    document.addEventListener('scroll', checkElementInViewPort);
                                }
                            }
                        }
                    }

                    function playCurrentAnimation() {
                        if (isHoverRemovedOnMobile) {
                            $(lottieEl).on('ready',
                                () => {
                                    safePlay(lottieEl);
                                    isHoverRemovedOnMobile = false;
                                });
                        } else {
                            safePlay(lottieEl);
                        }

                    }
                }
            }
        }

        LottieAnimation.init = function init(args) {
            return args.IsEditorEditing === true
                ? null
                : new LottieAnimation(args.scope);
        };

        return LottieAnimation;
    });
